import React from "react";

//utilities
import { getContentIdFromContentUrl } from "../search/utility";
import { BuildPath } from "@/helpers/Paths";

//interfaces
import { IAcknowledgementsOverviewProps } from "@/interfaces/acknowledgements";



const AcknowledgementsOverview: React.FC<IAcknowledgementsOverviewProps> = ({responses, contentIsArchived}) => {

    const contentId = getContentIdFromContentUrl(window.location.href);
    const imagePath = `${BuildPath()}/images/download-report.svg`;
    
    const downloadLink = () => {
      return (
      <div className="acknowledgements-overview-section">

        <span className="acknowledgements-overview-section-icon">
          <img className="download-report-image" src={imagePath} alt="" />
        </span>

        <a className="acknowledgement-report-link" href={`../../Content/DownloadAcknowledgementCsvReport?contentId=${contentId}`} id="acknowledgements-csv-url">
          Download CSV - Report
        </a>

      </div>
      )
    }

    return (
      <div id="acknowledgements-overview-container" className="acknowledgements-overview-container">
        
        <div className="acknowledgements-overview-section">
          <span id="acknowledgements-response-rate-number" className="acknowledgements-response-rate">
            Response Rate: {responses}%
          </span>
        </div>

        {(!contentIsArchived) && downloadLink()}

      </div>
    );
  }

export default AcknowledgementsOverview;
